import Amplify from "@aws-amplify/core";
import Auth from "@aws-amplify/auth";
// import { generateChallenge } from "Utils";
console.log("Auth", process.env);
Amplify.configure({
  Auth: {
    region: `${process.env.REACT_APP_REGION}`,
    userPoolId: `${process.env.REACT_APP_USER_POOL_ID}`,
    userPoolWebClientId: `${process.env.REACT_APP_CLIENT_ID}`,
    oauth: {
      domain: `${process.env.REACT_APP_HOSTED_UI_DOMAIN}`,
      scope: ["email", "profile", "openid", "aws.cognito.signin.user.admin"],
      redirectSignIn: `${process.env.REACT_APP_REDIRECT_SIGNIN}`,
      responseType: "code",
      //   code_challenge_method: "S256",
      //   code_challenge: generateChallenge(),
    },
  },
});

export const currentConfig = Auth.configure();
